<div class="raptor-call-to-action-container">
  <ng-container [ngSwitch]="componentDetails.settings.style">
    <!-- Link -->
    <ng-container *ngSwitchCase="'link'">
      <a mat-button color="primary" (click)="doAction()">{{ componentDetails.heading }}</a>
    </ng-container>

    <!-- button -->
    <ng-container *ngSwitchDefault>
      <button mat-flat-button color="primary" type="button" (click)="doAction()">{{ componentDetails.heading }}</button>
    </ng-container>
  </ng-container>
</div>
